export default {"src":"/_next/static/media/sri-lanka.37f9c734.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};